import React from 'react';

export default function CompanyInfo() {
  return (
    <section style={{padding: '3rem 1rem', maxWidth: 700, margin: '0 auto'}}>
      <h1 style={{textAlign: 'center', fontSize: '2.2rem', marginBottom: '2rem'}}>About Us</h1>
      <p>Just Feasible Solutions LLC - is a software company focused on building practical productivity applications that help people organize tasks, manage time, and work more efficiently.</p>
      <p>We design mobile apps that emphasize clarity, reliability, and ease of use. Our products are created to support everyday workflows, reduce friction, and make it easier for users to stay focused on what matters most.</p>
      <p>Our applications are continuously improved through user feedback and ongoing iteration, with a strong focus on performance, privacy, and long-term usability.</p>
      <h2 style={{marginTop: '2rem'}}>What We Build</h2>
      <ul>
        <li>Task and workflow management tools</li>
        <li>Time tracking and organization apps</li>
        <li>Focus, planning, and efficiency utilities</li>
        <li>Cross-platform mobile productivity solutions</li>
      </ul>
      <h2 style={{marginTop: '2rem'}}>Our Principles</h2>
      <ul>
        <li>Simplicity first — tools should be easy to understand and use</li>
        <li>Respect for privacy — we collect only what’s necessary</li>
        <li>Consistency and reliability — apps users can depend on daily</li>
        <li>Continuous improvement — guided by real user needs</li>
      </ul>
      <h2 style={{marginTop: '2rem'}}>Contact</h2>
      <p>For app support, feedback, or business inquiries:</p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:support@justfeasible.com">support@justfeasible.com</a></li>
        <li><strong>Location:</strong> Herndon, VA, USA</li>
      </ul>
    </section>
  );
}
